import type { GridElementsDetailsByCalculationType } from '../../derived-state/gridElementsDetailsByCalculationType/GridElementsDetails';
import { GridElementLoadFlowDetailsWithResults } from '../../derived-state/gridElementsDetailsByCalculationType/loadFlow/gridElementLoadFlowDetails.types';
import type { GridElementPropertyAttentionStatusByCalculationType } from '../AttentionStatusRepository';
import {
  type GridElementPropertyAttentionStatus,
  AttentionStatusProvider
} from '../AttentionStatusRepository';
import { EvaluatedResult } from '../EvaluatedResult';

export function anyLoadFlowElementRequiresAttention(
  attentionStatuses: GridElementPropertyAttentionStatus[]
) {
  const statusProvider =
    AttentionStatusProvider.createFromState(attentionStatuses);
  const elementsRequiringAttention = statusProvider.getAllAttentionRequired();
  return elementsRequiringAttention.length > 0;
}

export function getLoadFlowDetailsGridElementsRequiringAttention(
  evaluatedElements: GridElementsDetailsByCalculationType,
  attentionStatuses: GridElementPropertyAttentionStatus[]
) {
  const elementsRequiringAttentionIds =
    getElementsRequringAttentionIds(attentionStatuses);

  return evaluatedElements.loadFlow.filter(
    element => elementsRequiringAttentionIds.includes(element.id) && hasResults(element) && anyRequiresAttention(element.results)
  );
}
export function getLoadFlowIssuesGridElementsIdsRequiringAttention(
  statusesByType: GridElementPropertyAttentionStatusByCalculationType
) {
  const statusProvider = AttentionStatusProvider.createFromState(
    statusesByType.loadFlow
  );

  return getElementsRequiringAttentionIds(statusProvider);
}

export function countLoadFlowIssuesRequiringAttention(
  statusesByType: GridElementPropertyAttentionStatusByCalculationType
): number {
  const gridElementsRequiringAttentionInlowCalculation =
    getLoadFlowIssuesGridElementsIdsRequiringAttention(statusesByType);

  return gridElementsRequiringAttentionInlowCalculation.length;
}

export function countLoadFlowGridElementsRequiringAttention(
  statusesByType: GridElementPropertyAttentionStatusByCalculationType
): number {
  const gridElementsRequiringAttentionInLoadFlowCalculation =
    getLoadFlowIssuesGridElementsIdsRequiringAttention(statusesByType);

  const uniqueElementsCount = new Set([
    ...gridElementsRequiringAttentionInLoadFlowCalculation
  ]).size;
  return uniqueElementsCount;
}

function getElementsRequringAttentionIds(
  attentionStatuses: GridElementPropertyAttentionStatus[]
) {
  const statusProvider =
    AttentionStatusProvider.createFromState(attentionStatuses);

  return getElementsRequiringAttentionIds(statusProvider);
}

function getElementsRequiringAttentionIds(
  statusProvider: AttentionStatusProvider
) {
  const elementsRequiringAttentionIds = statusProvider
    .getAllAttentionRequired()
    .map(m => m.gridElementId);

  return elementsRequiringAttentionIds;
}
function hasResults(details: GridElementsDetailsByCalculationType['loadFlow'][number]): details is GridElementLoadFlowDetailsWithResults {
  return details.objectType !== "ExternalNetworkInjection"
}

function anyRequiresAttention(results: Record<string, EvaluatedResult<any>>): boolean {
  return Object.values(results).some(
    result => result.status === 'ATTENTION_REQUIRED'
  );
}

